import { render, staticRenderFns } from "./datasharing.vue?vue&type=template&id=4cfa4336&scoped=true"
import script from "./datasharing.vue?vue&type=script&lang=js"
export * from "./datasharing.vue?vue&type=script&lang=js"
import style0 from "./datasharing.vue?vue&type=style&index=0&id=4cfa4336&prod&scoped=true&lang=css"
import style1 from "./datasharing.vue?vue&type=style&index=1&id=4cfa4336&prod&lang=scss"
import style2 from "./datasharing.vue?vue&type=style&index=2&id=4cfa4336&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfa4336",
  null
  
)

export default component.exports